import { render, staticRenderFns } from "./ControllerBannerImageMap.vue?vue&type=template&id=27117644&"
import script from "./ControllerBannerImageMap.vue?vue&type=script&lang=ts&"
export * from "./ControllerBannerImageMap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports